<template>

  <v-container fluid class="pickup-confirmation-badge" style="max-width:550px;">

    <!-- Title and refresh/close actions -->
    <v-row class="mt-0">
      <v-col cols="9" xs="9" sm="9" md="9" lg="9" class="pt-0">
        <span class="title-text">
          {{ titleText }}
        </span>
      </v-col>
      <v-col cols="3" xs="3" sm="3" md="3" lg="3" align="center" class="pl-0 pt-0">
        <span class="pr-8"><v-icon color="primary" @click="loadBadgeData">mdi-refresh</v-icon></span>
        <span><v-icon color="primary" @click="closeBadge">mdi-window-close</v-icon></span>
      </v-col>
    </v-row>

    <!-- Order number -->
    <v-row class="mt-1">
      <v-col align="center" justify="center">
        <span class="pr-3 field-label-text">Order:</span>
        <span class="order-number-text">{{ order.order_number }}</span>
      </v-col>
    </v-row>

    <!-- FA card -->
    <v-row class="mt-0">
      <v-col align="center" justify="center">
        <div class="image-container">
          <v-progress-circular indeterminate :size="40" style="margin-top:40%;" color="primary" v-if="isFaLicenseLoading" />
          <div style="margin-top:40%;" class="error-text" v-else-if="faLicenseLoadingError">{{ faLicenseLoadingError }}</div>
          <img id="img" style="max-width:77%;max-height:50%;" :src="imageFaLicense" v-else-if="imageFaLicense" />
        </div>
      </v-col>
    </v-row>

    <!-- Confirmation code -->
    <v-row class="mt-1" v-if="showConfirmCode">
      <v-col align="center" justify="center" class="pa-0">
        <div>
          <v-progress-circular indeterminate :size="40" color="primary" v-if="isConfirmationCodeLoading" />
          <div class="pt-4 pb-2 error-text" v-else-if="confirmationCodeLoadingError">{{ confirmationCodeLoadingError }}</div>
          <template v-else-if="orderConfirmationCode">
            <div class="field-label-text">Confirmation Code</div>
            <div class="confirmation-code-text">{{ orderConfirmationCode.confirmation_code }}</div>
          </template>
        </div>
      </v-col>
    </v-row>

  </v-container>

</template>

<script>
export default {
  name: 'DeliveryOrderPickupConfirmationBadge',

  props: {
    order: {
      type: Object,
      required: true
    },
    showConfirmCode: {
      type: Boolean,
      default: true
    }
  },

  data () {
    return {
      isFaLicenseLoading: false,
      isConfirmationCodeLoading: false,
      faLicenseLoadingError: null,
      confirmationCodeLoadingError: null,
      imageFaLicense: null,
      orderConfirmationCode: null
    }
  },

  computed: {
    titleText () {
      return 'Pickup Confirmation'
    }
  },

  beforeMount () {
    // Load FA card image and order confirmation code
    this.loadBadgeData()
  },

  methods: {
    // Emit close action
    closeBadge () {
      this.$emit('close')
    },

    async loadBadgeData () {
      this.loadFaLicenseImage()
      this.loadOrderConfirmationCode()
    },

    // Load driver's FA card
    async loadFaLicenseImage () {
      this.isFaLicenseLoading = true
      this.faLicenseLoadingError = null

      const faLicenseUrl = await this.$root.fetchUserAsset('fa_license')
      if (faLicenseUrl) this.imageFaLicense = faLicenseUrl
      else this.faLicenseLoadingError = 'FA card cannot be loaded'

      this.isFaLicenseLoading = false
    },

    // Lookup order confirmation code
    async loadOrderConfirmationCode () {
      this.isConfirmationCodeLoading = true
      this.confirmationCodeLoadingError = null

      try {
        this.orderConfirmationCode = await this.$store.dispatch('sh/dataApi', {
          method: 'get',
          uri: `order/${this.order.id}/confirmation-code`
        })
      } catch (err) {
        switch (err.status) {
          case 404: this.confirmationCodeLoadingError = 'Confirmation code not found'; break
          default: this.confirmationCodeLoadingError = err.message || err.text || err
        }
      } finally {
        this.isConfirmationCodeLoading = false
      }
    }
  }
}
</script>

<style>
  .pickup-confirmation-badge .title-text {
    font-size: 1.1rem;
    color: #525252;
    letter-spacing: 0.8px;
    text-transform: uppercase !important;
  }

  .pickup-confirmation-badge .field-label-text {
    color: #9c9c9c;
  }

  .pickup-confirmation-badge .error-text {
    color: #FFA000;
    font-size: 1.2rem;
  }

  .pickup-confirmation-badge .order-number-text {
    font-size: 1.9rem;
  }

  .pickup-confirmation-badge .confirmation-code-text {
    font-family: 'Courier New', monospace;
    letter-spacing: 3.4px;
    font-size: 2.6rem;
  }

  .pickup-confirmation-badge .image-container {
    border: 1px solid #525252;
    border-radius: 6px;
    padding: 12px 0 10px 0;
    width: 320px;
    min-height: 350px;
    text-align: center;
  }

  .pickup-confirmation-badge .image-container img {
    max-height: 450px !important;
  }
</style>
